import { render } from "./ConfigCardOverlay.vue?vue&type=template&id=6bcaad22&scoped=true&ts=true"
import script from "./ConfigCardOverlay.vue?vue&type=script&lang=ts"
export * from "./ConfigCardOverlay.vue?vue&type=script&lang=ts"

import "./ConfigCardOverlay.vue?vue&type=style&index=0&id=6bcaad22&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bcaad22"]])

export default __exports__